import { connect, mapProps } from '@formily/react'
import { Textarea as UITextarea } from '@/components/ui/textarea'
import type { TextareaHTMLAttributes } from 'react'
import { useState, useEffect } from 'react'

export interface FormilyTextareaProps
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  value?: string
  onChange?: (value: string) => void
}

const InternalTextarea = ({
  value,
  onChange,
  className,
  ...props
}: FormilyTextareaProps) => {
  // Check if this is the Custom Instructions field based on placeholder or other props
  const isCustomInstructions =
    props.placeholder?.toLowerCase().includes('custom instructions') ||
    props.placeholder?.toLowerCase().includes('tell us where to show') ||
    props.placeholder?.toLowerCase().includes('instructions') ||
    props.placeholder?.toLowerCase().includes('where to show this video') ||
    (props as any)?.['data-field-name']?.toLowerCase().includes('instructions')

  const customClassName = isCustomInstructions
    ? 'bg-white/10 rounded-xl border-0 focus:ring-0 focus:outline-none focus-visible:ring-0 focus-visible:ring-offset-0'
    : ''

  // Responsive rows: 5 for desktop, 4 for mobile
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  // Use provided rows or default to responsive rows
  const rows = props.rows || (isMobile ? 4 : 5)

  return (
    <UITextarea
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      className={`${className || ''} ${customClassName}`.trim()}
      rows={rows}
      {...props}
    />
  )
}

export const FormilyTextarea = connect(
  InternalTextarea,
  mapProps((props) => ({
    ...props,
    value: props.value || '',
  })),
)
